// extracted by mini-css-extract-plugin
export default {"accordion_header":"AccordionItem_accordion_header__x8Kxo"};